import { useState, useEffect } from "react";

const AGE_GATE_KEY = "exo_age_verified";

const AgeGate = ({ children }) => {
  const [verified, setVerified] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(AGE_GATE_KEY);
    if (stored === "true") {
      setVerified(true);
    }
    setChecking(false);
  }, []);

  const handleVerify = () => {
    localStorage.setItem(AGE_GATE_KEY, "true");
    setVerified(true);
  };

  const handleReject = () => {
    window.location.href = "https://www.google.com";
  };

  if (checking) return null;

  if (verified) return children;

  return (
    <div className="fixed inset-0 z-[9999] bg-[#0a0a0f] flex items-center justify-center">
      <div className="text-center px-6 max-w-lg">
        {/* Logo / Brand */}
        <div className="mb-8">
          <img
            src="/images/exo-logo-medium.png"
            alt="Exo Entertainment"
            className="h-16 sm:h-20 w-auto mx-auto"
          />
          <div className="w-24 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mt-4" />
        </div>

        {/* Warning Icon */}
        <div className="text-6xl mb-6">🔞</div>

        {/* Message */}
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
          Age Verification Required
        </h2>
        <p className="text-gray-400 mb-2 text-base">
          This website contains adult-oriented content.
        </p>
        <p className="text-gray-400 mb-8 text-base">
          You must be <span className="text-gold font-semibold">18 years or older</span> to enter this site.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleVerify}
            className="px-8 py-3 bg-gold text-black font-bold text-lg rounded-full hover:bg-gold-light transition-all duration-300 shadow-lg shadow-gold/30"
          >
            I Am 18 or Older — Enter
          </button>
          <button
            onClick={handleReject}
            className="px-8 py-3 border border-gray-600 text-gray-400 font-medium text-lg rounded-full hover:border-gray-400 hover:text-white transition-all duration-300"
          >
            I Am Under 18 — Leave
          </button>
        </div>

        {/* Legal text */}
        <p className="text-gray-600 text-xs mt-8 max-w-sm mx-auto">
          By entering this site, you confirm that you are of legal age in your jurisdiction
          and agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
